import React from 'react';
import { useNavigate } from 'react-router-dom';
import Pagination from 'components/pager/Pagination';
import Spinner from 'components/loader/Spinner';
import Header, { ButtonConfig } from 'components/header/Header';
import useClusterList from './hooks/useClusterList';
import ClusterCard from './components/ClusterCard';
import useClusterLabels from './hooks/useClusterLabels';
import AutocompleteSearchBar from 'components/search/AutocompleteSearchBar';
import EmptySearchResult from 'components/search/EmptySearchResult';

const WarehouseList = () => {
    const { items, error, loading, filter, setFilter } = useClusterList();
    const { labels, loadingLabels } = useClusterLabels(items.count);

    const navigate = useNavigate();

    const buttonConfig: ButtonConfig[] = [
        {
            label: 'Create Warehouse',
            onClick: () => navigate('/new-warehouse'),
        },
    ];

    return (
        <div>
            <Header title="Warehouses" buttonConfigs={buttonConfig} />
            <AutocompleteSearchBar
                onTermChange={(e: string) => {
                    setFilter({ ...filter, term: e });
                }}
                items={labels}
                loading={loadingLabels}
                placeholder="Search among your warehouses..."
            />
            {loading ? (
                <Spinner />
            ) : (
                !error &&
                (items.nodes.length === 0 ? (
                    <EmptySearchResult />
                ) : (
                    <div>
                        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-16">
                            {items.nodes.map((item) => (
                                <ClusterCard {...item} />
                            ))}
                        </div>
                        {!loading && items.count > 0 && (
                            <Pagination
                                items={items}
                                filter={filter}
                                setFilter={setFilter}
                            />
                        )}
                    </div>
                ))
            )}
        </div>
    );
};

export default WarehouseList;
